function getAllContainers(selector) {
    const containers = [];
    containers.push(...Array.from(document.querySelectorAll(selector)).filter((el) => el instanceof HTMLElement));
    const allElements = Array.from(document.querySelectorAll('*')).filter((el) => el instanceof HTMLElement);
    allElements.forEach(element => {
        const { shadowRoot } = element;
        if (shadowRoot) {
            containers.push(...Array.from(shadowRoot.querySelectorAll(selector)).filter((el) => el instanceof HTMLElement));
        }
    });
    return containers;
}
function getTilesFromShadow(container, tagName, tileSelector) {
    const slot = container.querySelector('slot');
    if (!slot)
        return [];
    const assigned = slot.assignedElements({ flatten: true });
    return assigned
        .map(el => {
        var _a, _b;
        return ((_b = (_a = el
            .querySelector(tagName)) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(tileSelector)) || null;
    })
        .filter((tile) => tile !== null);
}
function updateTileHeights(tiles) {
    tiles.forEach(originalTile => {
        const tile = originalTile;
        tile.style.height = 'auto';
        tile.style.maxHeight = 'none';
    });
    const maxHeight = Math.max(...tiles.map(tile => tile.clientHeight || 0));
    tiles.forEach(originalTile => {
        const tile = originalTile;
        tile.style.height = `${maxHeight}px`;
        tile.style.maxHeight = `${maxHeight}px`;
        tile.style.overflow = 'hidden';
    });
}

export { getAllContainers, getTilesFromShadow, updateTileHeights };
